function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { spacing8, spacing16 } from "@churchofjesuschrist/eden-style-constants";
const ConstrainStyled = styled(_ref => {
  let { ...props
  } = _ref;
  delete props.size;
  return /*#__PURE__*/React.createElement("div", props);
}).withConfig({
  componentId: "sc-wurhft-0"
})(["position:relative;padding:", " ", " 0;margin-block-end:", ";overflow:hidden;max-width:100%;height:", ";", ";"], spacing16, spacing8, spacing8, _ref2 => {
  let {
    size
  } = _ref2;
  return size === "flex" ? "auto" : size === "compact" ? "7rem" : "8.75rem";
}, props => props.size !== "flex" && css(["&::after{content:\"\";position:absolute;height:25%;left:0;right:0;bottom:0;background:linear-gradient( to top,rgb(255,255,255) 0,rgba(255,255,255,0) 100% );}"]));

const Constrain = _ref3 => {
  let {
    children,
    size = "default",
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(ConstrainStyled, _extends({
    size: size
  }, props), children);
};

Constrain.propTypes = {
  /** Contents to constrain */
  children: PropTypes.node.isRequired,

  /** Constrain to a Compact size */
  size: PropTypes.oneOf(["compact", "default", "flex"])
};
export default Constrain;